import React, { useEffect, useState } from "react";
import Main from "../components/Main";
import Row from "../components/Row";
import LiveRow from "../components/LiveRow";
import axios from "axios";
import SavedMunis from "../components/SavedMunis";
import { UserAuth } from "../context/AuthContext";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

const Home = () => {
  const [categories, setCategories] = useState([]);
  const [series, setSeries] = useState([]);
  const [liveStreams, setLiveStreams] = useState([]);
  const [liveMunis, setLiveMunis] = useState([]);
  const [likedMunis, setLikedMunis] = useState([]);
  const { user } = UserAuth();

  useEffect(() => {
    axios.get(process.env.REACT_APP_MUNI_JSON_URL).then((response) => {
      setCategories(response.data.categories);
      setSeries(response.data.series);
    });

    axios.get(process.env.REACT_APP_LIVE_STREAMS_JSON_URL).then((response) => {
      setLiveStreams(response.data);
    });
  }, []);

  useEffect(() => {
    const newLiveMunis = series.filter((muni) =>
      muni.episodes.some((episode) => {
        const episodeName = episode.content.videos[0].url
          .split("/")
          .slice(-3, -1)
          .join("/");
        return liveStreams.includes(episodeName);
      })
    );
    setLiveMunis(newLiveMunis);
  }, [series, liveStreams]);

  useEffect(() => {
    if (user?.uid) {
      const unsubscribe = onSnapshot(doc(db, "users", user.uid), (doc) => {
        setLikedMunis(doc.data()?.savedMunis || []);
      });

      // Cleanup subscription on unmount
      return () => unsubscribe();
    }
  }, [user?.uid]);

  const savedMuni = (muni) => {
    setLikedMunis((prevLikedMunis) => ({
      ...prevLikedMunis,
      [muni.id]: !prevLikedMunis[muni.id],
    }));
  };

  const slideLeft = (sliderId) => {
    const slider = document.getElementById(sliderId);
    if (slider) {
      slider.scrollLeft -= 500;
    }
  };

  const slideRight = (sliderId) => {
    const slider = document.getElementById(sliderId);
    if (slider) {
      slider.scrollLeft += 500;
    }
  };

  return (
    <>
      <div>
        <Main />
        <div className="mx-auto text-center py-8">
          <h1 className="text-white text-xl md:text-3xl font-bold">
            {" "}
            Select a thumbnail below to watch your favourite team's live and
            archived games{" "}
          </h1>
          {liveMunis.length == 1 && (
            <h3 className="text-red-800 text-lg md:text-2xl font-bold">
              {" "}
              There are currently no live games
            </h3>
          )}
        </div>
        {likedMunis.length > 0 && (
          <SavedMunis
            liveMunis={liveMunis}
            likedMunis={likedMunis}
            savedMuni={savedMuni}
            slideLeft={slideLeft}
            slideRight={slideRight}
          />
        )}

        {liveMunis.length > 0 && (
          <LiveRow
            liveMunis={liveMunis}
            likedMunis={likedMunis}
            savedMuni={savedMuni}
            slideLeft={slideLeft}
            slideRight={slideRight}
          />
        )}
        {categories.map((category, index) => {
          const filteredSeries = series.filter((item) =>
            item.tags.includes(category.query)
          );
          return (
            <Row
              key={index}
              rowID={index}
              title={category.name}
              tag={category.query}
              series={filteredSeries}
              liveStreams={liveStreams}
              likedMunis={likedMunis}
              savedMuni={savedMuni}
              slideLeft={slideLeft}
              slideRight={slideRight}
            />
          );
        })}
      </div>
    </>
  );
};

export default Home;
